var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState } from "react";
import { MessageContentType, MessageDirection, useChat } from "../useChat";
import { CustomImageMessage } from "./CustomImageMessage";
import { CustomTextMessage } from "./CustomTextMessage";
import { recallAdminMessage } from "../utils/chat";
export const CustomMessage = ({ message, direction, isFirstMessage = false, activeConversation, emitMessage }) => {
    var _a;
    const _useChat = useChat(), removeMessageByMessagedId = _useChat.removeMessageByMessagedId;
    const _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), pending = _useState2[0], setPending = _useState2[1];
    const hasServerId = /^\d+$/.test(String((_a = message.messagedId) !== null && _a !== void 0 ? _a : ""));
    // Admin can recall any bubble in 運営 conversation (outgoing admin or incoming user).
    const canRecall = hasServerId && !pending;
    const handleRecall = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!canRecall)
            return;
        if (!window.confirm("このメッセージを取り消しますか？\nユーザー側では表示されなくなります。")) {
            return;
        }
        setPending(true);
        try {
            yield recallAdminMessage(message.messagedId);
            removeMessageByMessagedId(message.messagedId, activeConversation === null || activeConversation === void 0 ? void 0 : activeConversation.id);
        }
        catch (error) {
            alert(error instanceof Error ? error.message : "メッセージの取り消しに失敗しました。");
        }
        finally {
            setPending(false);
        }
    });
    const bubble = message.contentType === MessageContentType.Image ? /*#__PURE__*/ React.createElement(CustomImageMessage, {
        message: message,
        direction: direction,
        isFirstMessage: isFirstMessage,
        sendImageMessage: url => {
            if (activeConversation === null || activeConversation === void 0 ? void 0 : activeConversation.id) {
                emitMessage(url, activeConversation.id, "image");
            }
        },
        user: activeConversation === null || activeConversation === void 0 ? void 0 : activeConversation.data
    }) : /*#__PURE__*/ React.createElement(CustomTextMessage, {
        message: message,
        direction: direction,
        isFirstMessage: isFirstMessage,
        user: activeConversation === null || activeConversation === void 0 ? void 0 : activeConversation.data
    });
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            position: "relative"
        }
    }, bubble, canRecall && /*#__PURE__*/ React.createElement("div", {
        style: {
            display: "flex",
            justifyContent: direction === MessageDirection.Outgoing ? "flex-end" : "flex-start",
            marginTop: 2,
            marginLeft: direction === MessageDirection.Incoming ? 45 : 0,
            marginBottom: 4
        }
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        onClick: handleRecall,
        disabled: pending,
        style: {
            border: "none",
            background: "transparent",
            color: "#6b7280",
            fontSize: 12,
            cursor: pending ? "not-allowed" : "pointer",
            padding: "0 4px",
            textDecoration: "underline"
        }
    }, pending ? "取消中..." : "取り消す")));
};
